import "../css/HeroBG.css";
import { Flex, Col, Row } from "antd";
import { useQuery } from "@apollo/client";
import { GET_HOME_HERO_BY_SLUG, GET_SECTION_SEO } from "../queries";
import { useState } from "react";
import { getFromLocalStorage, saveToLocalStorage } from "../utils/localStorage";
import useIsMobile from '../utils/isMobile'
import ButtonComp from "./ButtonComp";
import setImageAbsoluteUrl from "../utils/setImageAbosulteUrl"

const HeroBG = ({ page, section, lang }) => {
  const isMobile = useIsMobile();
  const slug = `${page}-${section}-${lang}`;

  const [sectionData, setSectionData] = useState(() => {
    const cachedData = getFromLocalStorage(page);
    return cachedData?.sections?.[slug] || null;
  });
  
  const { loading, error } = useQuery(GET_HOME_HERO_BY_SLUG, {
    variables: { slug },
    skip: !!sectionData,
    onCompleted: (fetchedData) => {
      const postData = fetchedData.sectionsBy?.homeHero;
      const dataToLocal = {
        ...sectionData,
        sections: {
          [slug]: postData,
        },
      };
      saveToLocalStorage(page, dataToLocal);
      setSectionData(postData);
    },
  });
  
  return (
    <>
    {
      sectionData && (
        <>
          <Flex vertical className="HeroBG" justify="center" align="center">
            <Row>
              <Col span={24}>
                <Flex className="hero-content">
                  <img
                    loading="lazy"
                    className="logo-hero-home"
                    alt={sectionData?.logoHeroHome?.node?.slug || "Placeholder"}
                    src={
                      setImageAbsoluteUrl(sectionData?.logoHeroHome?.node?.mediaItemUrl) || "placeholder.png"
                    }
                  />
                </Flex>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Flex className="h1-headline-800 hero-content">
                  <h1
                    dangerouslySetInnerHTML={{ __html: sectionData?.tituloHeroHome }}
                  />
                </Flex>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Flex className={isMobile ? "b2-body-400-mobile hero-content" : "b2-body-400 hero-content"}>
                  <p
                    dangerouslySetInnerHTML={{ __html: sectionData?.subtituloHomeHero }}
                  />
                </Flex>
              </Col>
            </Row>
            <Row className="button-row">
              <Col span={24}>
                <ButtonComp 
                  title={sectionData?.ctaHomeHero?.title} 
                  url={sectionData?.ctaHomeHero?.url} 
                  classStyle={sectionData?.estiloBoton ? sectionData?.estiloBoton : 'button-yellow-md'}
                />
              </Col>
            </Row>
          </Flex>
        </>
      )
    }
    </>
  );
};

export default HeroBG;
